import { getSupportedLocale } from '@ms/yammer-i18n';
import { Action } from 'redux';

import { Locale } from '../../state/types';

export interface LocaleSetAction extends Action {
  readonly type: '@@yammer-i18n-react/LOCALE.SET';
  readonly payload: Locale;
}

export type TranslationOverride = 'control' | 'enable_vietnamese' | 'enable_all';

type SetLocale = (locale: Locale, translationOverride?: TranslationOverride) => LocaleSetAction;

export const setLocale: SetLocale = (locale, translationOverride) => {
  const supportedLocale = getSupportedLocale(locale, translationOverride);

  return {
    type: '@@yammer-i18n-react/LOCALE.SET',
    payload: supportedLocale,
  };
};
